// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const organizationGroupWorkspaceListQuerySchema = z
  .object({
    organization: idSchema.optional(),
  })
  .and(paginationQuerySchema);
